import React, { Component } from "react";
import { Tabs, Form, Spin, Button, message } from "antd";
import "./Calculation.scss";
import { connect } from "react-redux";
import CalculationSummary from "./CalculationSummary";
import {
  GetFinancingRequestDetails,
  GetFinancingRequestAccountingHistory,
  UpdateOrderStatus,
} from "../../network/customer.network";
import { GetFinancingAgencyEmployeesByAgencyId } from "../../network/profile.network";
import { setUserRequest } from "../../redux/user/user.action";
import CalcStatuse from "./CalcStatuse";
import { FaTimes, FaCheckCircle, FaPaperPlane } from "react-icons/fa";
import moment from "moment";

const { TabPane } = Tabs;

class Calculation extends Component {
  formUserRef = React.createRef();
  formEditCalcRef = React.createRef();
  state = {
    accountingList: [],
    accountingListRealestate: [],
    RequestAccountingHistory: [],
    agencyEmployees: [],
    isModalVisible: false,
    showTimeline: false,
    calcSelect: false,
    calcSelectRealestate: true,
    confirmLoading: false,
    isCalcEdit: false,
    isRealestateFinancing: true,
    showEmpWarning: false,
    selectedAccountInfo: null,
    selectedAccountInfoRealestate: null,
    selectedAccountId: null,
    StatusLogs: null,
    selectedAccountIdRealestate: null,
    FinancingAgencyEmployeeId: null,
    FinancingRequestTypeId: "3",
    acceptLoading: false,
    loadingCancel: false,
  };

  componentDidMount() {
    this.handelGetFinancingRequestDetails();
  }

  handelGetFinancingRequestAccountingHistory = () => {
    const { orderId } = this.props;
    const { FinancingRequestTypeId } = this.state;
    this.setState({ tabLoading: true });
    GetFinancingRequestAccountingHistory(
      orderId,
      FinancingRequestTypeId,
      (res) => {
        this.setState({
          RequestAccountingHistory: res.data.model,
          tabLoading: false,
        });
      },
      (err) => {
        //console.log(err);
        this.setState({ tabLoading: false });
      }
    );
  };

  handelGetFinancingRequestDetails = () => {
    const { userRequest, orderId } = this.props;
    this.setState({ tableLoading: true });
    GetFinancingRequestDetails(
      orderId ? orderId : userRequest?.Id,
      (res) => {
        this.setState({
          FinancingRequestDetails: res.data.model,
          StatusLogs: res.data.model?.FinancingRequestGeneralStatusLogs,
          tableLoading: false,
          isRealestateFinancing: res.data.model.RealestateFinancingRequest,
        });
        if (res.data.model.CarFinancingRequest?.FinancingRequestAccounting) {
          this.setState({
            calcSelectRealestate: true,
            selectedAccountIdRealestate:
              res.data.model?.RealestateFinancingRequest
                ?.FinancingRequestAccounting,
          });
        }
        this.props.dispatch(setUserRequest(res.data.model));

        setTimeout(() => {
          this.setState({
            FinancingRequestTypeId: "3",
          });
          setTimeout(() => {
            if (this.props.orderId) {
              // this.handelGetFinancingRequestAccountingHistory();
            } else {
              this.setState({ tabLoading: false });
            }
          }, 300);
        }, 500);
      },
      (err) => {
        this.setState({ tableLoading: false });
      }
    );
  };
  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys, isModalVisible: true });
  };
  handelChangeGenralStatus = (stateId) => {
    const { userData } = this.props;
    if (stateId === 3 || stateId === 6) {
      this.setState({ acceptLoading: true });
    }
    if (stateId === 5) {
      this.setState({ loadingCancel: true });
    }
    UpdateOrderStatus(
      userData?.Id,
      stateId,
      (res) => {
        this.setState({ acceptLoading: false });
        if (stateId === 3 || stateId === 6) {
          message.success("تم ارسال الموافقه علي الحسبه بنجاح");
          this.props.handelGetOrderDetails();
        }
        if (stateId === 5) {
          message.success("تم رفض الحسبه");
          this.setState({ loadingCancel: false });
          this.props.handelGetOrderDetails();

          // this.handeldeleteOrder();
        }
      },
      (err) => {
        this.setState({
          loadingOk: false,
          loadingCancel: false,
          loading: false,
        });
        //console.log(err);
      }
    );
  };

  render() {
    const { calcSelectRealestate, tabLoading, loadingCancel, acceptLoading } =
      this.state;
    const { userRequest, userData } = this.props;
    console.log(userData, "55555555555555555555555555");
    return (
      <div className="finance-tab-content calculation-page">
        <h2 className="tab-title">الحسبة</h2>

        <CalculationSummary userRequest={userRequest} />

        <Form id="orderForm3" onFinish={this.props.submitForm}></Form>

        <Spin spinning={false}>
          <div className="calc-tabs">
            <Form
              className="form-add-content funder-form-holder"
              layout="vertical"
              name="nest-messages"
              id="orderForm3"
              ref={this.formUserRef}
              onFinish={this.onFinish}
            >
              <Tabs>
                <TabPane tab="تمويل سيارات" key="3">
                  {userData?.FinanceRequestStatus?.Id === 1 && (
                    <div className="calc-timeline is-osool-statues">
                      <div className="timeline-row-holder">
                        <p className="timeline--p">
                          {userData?.FinanceRequestStatus?.NameLT}
                        </p>
                        <time className="timeline--time">
                          {moment
                            .utc(userData?.FinanceRequestStatus?.CreationDate)
                            .local()
                            .format("YYYY/M/D - HH:MM")}
                        </time>
                      </div>
                    </div>
                  )}
                  {userData?.DepositPersentage && (
                    <div
                      className={`calc-summary-holder calc-summary-send-holder support-reply`}
                    >
                      <div className="summary-col">
                        <div className="summary-info-row">
                          <p>جهه التمويل</p>
                          <h5>{userData?.Bank?.NameLT}</h5>
                        </div>
                        <div className="summary-info-row">
                          <p>نسبة الدفعة المقدمة</p>
                          <h5>
                            {userData?.DepositPersentage}
                            <span> % </span>
                          </h5>
                        </div>

                        <div className="summary-info-row">
                          <p>نسبة الدفعة الاخيرة </p>
                          <h5>
                            {userData?.LastInstallmentPersentage}
                            <span> % </span>
                          </h5>
                        </div>

                        <div className="summary-info-row">
                          <p>نسبة المصاريف الادارية </p>
                          <h5>
                            {userData?.AdministrativeExpensePersentage}
                            <span> % </span>
                          </h5>
                        </div>
                        <div className="summary-info-row">
                          <p>عدد الاقساط</p>
                          <h5>{userData?.InstallmentCount}</h5>
                        </div>
                        <div className="summary-info-row">
                          <p>نسبة التأمين </p>
                          <h5>
                            {userData?.InsurancePersentage}
                            <span> % </span>
                          </h5>
                        </div>
                        {/* ///////////////////////////////////////////////////// */}

                        <div className="summary-info-row">
                          <p>نسبة كلفة التمويل </p>
                          <h5>
                            {userData?.FinancingCostPersentage}
                            <span> % </span>
                          </h5>
                        </div>
                      </div>
                      <div className="summary-col">
                        <div className="summary-info-row">
                          <p>قيمة التمويل</p>
                          <h5>
                            {userData?.FinancingValue}
                            <span>ر.س</span>
                          </h5>
                        </div>
                        <div className="summary-info-row">
                          <p>قيمة الدفعة المقدمة</p>
                          <h5>
                            {userData?.DepositValue}
                            <span>ر.س</span>
                          </h5>
                        </div>
                        <div className="summary-info-row">
                          <p>قيمة القسط الاخير</p>
                          <h5>
                            {userData?.LastInstallmentValue}
                            <span>ر.س</span>
                          </h5>
                        </div>
                        <div className="summary-info-row">
                          <p>قيمة المصاريف الادارية</p>
                          <h5>
                            {userData?.AdministrativeExpenseValue}
                            <span>ر.س</span>
                          </h5>
                        </div>

                        <div className="summary-info-row">
                          <p>مبلغ القسط</p>
                          <h5>
                            {userData?.InstallmentCost}
                            <span>ر.س</span>
                          </h5>
                        </div>

                        <div className="summary-info-row">
                          <p>قيمة التأمين</p>
                          <h5>
                            {userData?.InsuranceValue}
                            <span>ر.س</span>
                          </h5>
                        </div>
                        {/* ///////////////////////////////////////////////////// */}

                        <div className="summary-info-row">
                          <p>نسبة الربح</p>
                          <h5>
                            {userData?.ProfitPersentage}
                            <span> % </span>
                          </h5>
                        </div>
                        <div className="summary-info-row">
                          <p>قيمة الربح</p>
                          <h5>{userData?.ProfitValue}</h5>
                        </div>
                      </div>
                    </div>
                  )}
                  {userData?.Agency?.NameLT && (
                    <>
                      <h2>ميزات إضافية</h2>

                      <div
                        className={`calc-summary-holder calc-summary-send-holder support-reply`}
                      >
                        <div className="summary-col">
                          <div className="summary-info-row">
                            <p>اسم الوكيل</p>
                            <h5>{userData?.Agency?.NameLT}</h5>
                          </div>
                        </div>
                        <div className="summary-col">
                          <div
                            className="summary-info-row"
                            style={{ height: "auto" }}
                          >
                            <p>عروض الوكيل</p> &nbsp;&nbsp;&nbsp;
                            <h5>{userData?.Agency?.AgencyOffers}</h5>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {userData?.FinanceRequestStatus?.Id === 2 && (
                    <>
                      <div className={`finance-actions`}>
                        <Button
                          type="primary"
                          size="large"
                          gost
                          className="xlg blue-btn accept-calc-btn"
                          icon={<FaPaperPlane />}
                          loading={acceptLoading}
                          onClick={() => this.handelChangeGenralStatus(3)}
                        >
                          موافقه علي الحسبة المبدائيه
                        </Button>
                        <Button
                          type="primary"
                          size="large"
                          gost
                          className="xlg red-btn"
                          loading={loadingCancel}
                          onClick={() => this.handelChangeGenralStatus(5)}
                          icon={<FaTimes style={{ marginLeft: 10 }} />}
                        >
                          رفض
                        </Button>
                      </div>
                    </>
                  )}
                  {userData?.FinanceRequestStatus?.Id === 4 && (
                    <>
                      <div className={`finance-actions`}>
                        <Button
                          type="primary"
                          size="large"
                          gost
                          className="xlg blue-btn accept-calc-btn"
                          icon={<FaPaperPlane />}
                          loading={acceptLoading}
                          onClick={() => this.handelChangeGenralStatus(6)}
                        >
                          تاكيد الموافقه النهائيه
                        </Button>
                        <Button
                          type="primary"
                          size="large"
                          gost
                          className="xlg red-btn"
                          loading={loadingCancel}
                          onClick={() => this.handelChangeGenralStatus(5)}
                          icon={<FaTimes style={{ marginLeft: 10 }} />}
                        >
                          رفض
                        </Button>
                      </div>
                    </>
                  )}
                  {(userData?.FinanceRequestStatus?.Id === 3 ||
                    userData?.FinanceRequestStatus?.Id === 4 ||
                    userData?.FinanceRequestStatus?.Id === 6) && (
                    <div className="calc-timeline success">
                      <div className="timeline-row-holder">
                        <p className="timeline--p">
                          {userData?.FinanceRequestStatus?.NameLT}
                        </p>
                        <time className="timeline--time">
                          {moment
                            .utc(userData?.FinanceRequestStatus?.CreationDate)
                            .local()
                            .format("YYYY/M/D - HH:MM")}
                        </time>
                      </div>
                    </div>
                  )}
                  {userData?.FinanceRequestStatus?.Id === 5 && (
                    <div className="calc-timeline support-reply">
                      <div className="timeline-row-holder">
                        <p className="timeline--p">
                          {userData?.FinanceRequestStatus?.NameLT}
                        </p>
                        <time className="timeline--time">
                          {moment
                            .utc(userData?.FinanceRequestStatus?.CreationDate)
                            .local()
                            .format("YYYY/M/D - HH:MM")}
                        </time>
                      </div>
                    </div>
                  )}
                </TabPane>
              </Tabs>
            </Form>

            {/* {StatusLogs && (
              <CalcStatuse
                FinancingRequestTypeId={FinancingRequestTypeId}
                selectedAccountId={
                  selectedAccountId || selectedAccountIdRealestate
                }
                StatusLogs={StatusLogs}
              />
            )} */}
          </div>
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userRequest: state.user.userRequest,
  Customer: state.user?.currentUser,
});
export default connect(mapStateToProps)(Calculation);
